import { useState } from 'react';
import { VacationType } from 'src/tabs/hooks/useVacationTypes';
import axios from 'axios';
import { checkVacationTypeId } from 'src/utils/mappers/checkVacationType';
import { formatDate } from 'src/utils/dateFns/formatDate';
import { analyticsEventSend } from 'src/utils/analytics/analyticsEventSend';

export const useCreateRequest = (vacationTypes?: VacationType[]) => {
  const [request, setRequest] = useState();
  const [loadingRequest, setLoadingRequest] = useState<boolean>();

  const createRequest = async (requestsData) => {
    if (loadingRequest) return;
    const vacationTypeId = checkVacationTypeId(
      vacationTypes,
      requestsData.vacationType
    );

    try {
      setLoadingRequest(true);
      const {
        year: startYear,
        month: startMonth,
        day: startDay,
      } = formatDate(requestsData.startDate);
      const {
        year: endYear,
        month: endMonth,
        day: endDay,
      } = formatDate(requestsData.endDate);
      const { data } = await axios.post('api/vacation-requests/my', {
        startDate: `${startYear}-${startMonth}-${startDay}`,
        endDate: `${endYear}-${endMonth}-${endDay}`,
        employeeComment: requestsData.employeeComment,
        vacationTypeId: vacationTypeId,
      });
      data && setRequest(data);
      analyticsEventSend('New time-off request posted');
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingRequest(false);
    }
  };

  return { request, loadingRequest, createRequest };
};
